let mapper_options = {
  endpoint: 'assets',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      brand: {
        foreignKey: 'brand_id',
        localField: 'brand'
      },
      campaign: {
        foreignKey: 'campaign_id',
        localField: 'campaign'
      },
      digital_asset: {
        foreignKey: 'digital_asset_id',
        localField: 'digital_asset'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('asset', mapper_options)
}
